<template>
  <div class="container">
    <card :titulo="isRecuperacaoViaToken ? 'Gerar nova senha' : 'Acesso ao sistema'" classe="box login meio">
      <form id="form_trocar_senha" @submit.prevent="submitTrocarSenha">
        <div class="row col-md-12">
          <span class="mt-2 pt-2">
            {{ isRecuperacaoViaToken ? 'Defina uma nova senha para sua conta' : 'Cadastre uma nova senha do SIOP' }}
          </span>
          <span class="col-md-12"><br /></span>
          <div class="mb-3 row">
            <label class="col-md-4" for="nova_senha">Nova Senha:</label>
            <div class="input-group col-md-8">
              <input class="form-control" id="nova_senha" name="nova_senha" :type="novaSenhaShow ? 'text' : 'password'" placeholder="Informe nova senha" maxlength="64" autocomplete="new-password" required v-model="nova_senha" ref="nova_senha" />
              <span role="button" tabindex="0" :aria-label="novaSenhaShow ? 'Ocultar nova senha' : 'Mostrar nova senha'" :aria-pressed="novaSenhaShow ? 'true' : 'false'" @keydown.enter.prevent="novaSenhaShow = !novaSenhaShow" @keydown.space.prevent="novaSenhaShow = !novaSenhaShow" class="input-group-text" @click="novaSenhaShow = !novaSenhaShow">
                <i class="fa" aria-hidden="true" :class="!novaSenhaShow ? 'fa-eye' : 'fa-eye-slash'" />
              </span>
            </div>
          </div>
          <div class="mb-3 row">
            <label class="col-md-4" for="confirmacao_senha">Confirmação:</label>
            <div class="input-group col-md-8">
              <input class="form-control" id="confirmacao_senha" name="confirmacao_senha" :type="confirmacaoNovaSenhaShow ? 'text' : 'password'" placeholder="Confirme nova senha" maxlength="64" autocomplete="new-password" required v-model="confirmacao_senha" />

              <span role="button" tabindex="0" :aria-label="confirmacaoNovaSenhaShow ? 'Ocultar confirmação da senha' : 'Mostrar confirmação da senha'" :aria-pressed="confirmacaoNovaSenhaShow ? 'true' : 'false'" @keydown.enter.prevent="confirmacaoNovaSenhaShow = !confirmacaoNovaSenhaShow" @keydown.space.prevent="confirmacaoNovaSenhaShow = !confirmacaoNovaSenhaShow" class="input-group-text" @click="confirmacaoNovaSenhaShow = !confirmacaoNovaSenhaShow">
                <i class="fa" aria-hidden="true" :class="!confirmacaoNovaSenhaShow ? 'fa-eye' : 'fa-eye-slash'" />
              </span>
            </div>
            <span v-if="nova_senha && confirmacao_senha && nova_senha !== confirmacao_senha" class="text-danger col-md-8 offset-md-4">A confirmação deve ser igual a nova senha</span>
          </div>
          <div class="col-md-8 offset-md-4">
            <span>Sua senha deve ter pelo menos:</span>
            <ul>
              <li v-for="validacao of validacoesSenha" :key="validacao.label">
                <i class="fa" :class="validacao.test.test(nova_senha.trim()) ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'" />
                {{ validacao.label }}
              </li>
            </ul>
          </div>
          <p v-if="!isRecuperacaoViaToken" class="text-danger text-center m-2">Tempo restante para alterar a senha：{{ remaingTimeExp }}</p>
          <div>
            <button type="submit" class="btn btn-primary">Enviar</button>&nbsp;
            <button type="button" class="btn btn-outline-info" @click="cancelarTrocarSenha">Cancelar</button>
          </div>
        </div>
      </form>
    </card>
  </div>
</template>
<script>
import Card from './../Card.vue'
import UiConfig from '../../config/ui'
import bus from '../../bus.js'
import { jwtDecode } from 'jwt-decode'

export default {
  components: {
    card: Card
  },
  data: function () {
    return {
      login: '',
      senha: '',
      cpf: '',
      email: '',
      nova_senha: '',
      confirmacao_senha: '',
      urls: UiConfig.urls,
      trocarSenhaTokeExp: 300,
      remaingTimeExp: '',
      interval: null,
      novaSenhaShow: false,
      confirmacaoNovaSenhaShow: false,
      isRecuperacaoViaToken: false,
      tokenRecuperacao: null,
      validacoesSenha: [
        { label: '8 caracteres', test: /^.{8,}/ },
        { label: '1 letra minúscula', test: /^(?=.*[a-z])/ },
        { label: '1 letra maiúscula', test: /^(?=.*[A-Z])/ },
        { label: '1 número', test: /^(?=.*[0-9])/ },
        { label: '1 caractere especial (!@#$%^&*)', test: /^(?=.*[!@#$%^&*])/ }
      ]
    }
  },
  methods: {
    updateRemaingTime () {
      const remainingTotalSeconds = this.trocarSenhaTokeExp - Date.now() / 1000
      const remainingMinutes = Math.floor(remainingTotalSeconds / 60)
      const remainingSeconds = Math.floor(remainingTotalSeconds % 60)
      this.remaingTimeExp = remainingMinutes + ':' + (remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds)
      if (remainingTotalSeconds <= 0) {
        this.remaingTimeExp = '0:00'
        clearInterval(this.interval)
      }
    },
    submitTrocarSenha () {
      if (!this.nova_senha || !this.confirmacao_senha || this.nova_senha !== this.confirmacao_senha) {
        return
      }
      for (const validacao of this.validacoesSenha) {
        if (!validacao.test.test(this.nova_senha)) {
          return
        }
      }

      if (this.isRecuperacaoViaToken) {
        this.submitTrocarSenhaComToken()
      } else {
        this.submitTrocarSenhaNormal()
      }
    },
    async submitTrocarSenhaNormal () {
      const usuario = { novasenha: this.nova_senha }

      try {
        const response = await fetch(UiConfig.urls.auth.trocarSenha, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + window.localStorage.getItem('token')
          },
          body: JSON.stringify(usuario)
        })

        if (!response.ok) {
          const data = await response.json().catch(() => ({}))
          const mensagens = {
            404: 'Serviço de autenticação não encontrado',
            400: data.err === 'JWT is expired' ? 'Tempo limite para mudança de senha ultrapassado' : (data.err || 'Falha ao trocar senha'),
            401: data.err === 'JWT is expired' ? 'Tempo limite para mudança de senha ultrapassado' : (data.err || 'Falha ao trocar senha')
          }
          throw new Error(mensagens[response.status] || 'Falha ao trocar senha')
        }

        const usuarioToken = jwtDecode(window.localStorage.getItem('token'))
        this.login = usuarioToken.cpf
        this.senha = this.nova_senha
        bus.emit('siop-limpa-tudo')
        this.submitLogin()
      } catch (err) {
        bus.emit('siop-limpa-tudo')
        bus.emit('siop-erro', err.message || 'Falha ao trocar senha')
      }
    },
    async submitTrocarSenhaComToken () {
      const dados = {
        novasenha: this.nova_senha,
        token: this.tokenRecuperacao
      }

      try {
        const response = await fetch(UiConfig.urls.auth.trocarSenhaToken, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dados)
        })

        if (!response.ok) {
          const data = await response.json().catch(() => ({}))
          let mensagemErro

          if (response.status === 404) {
            mensagemErro = 'Serviço de autenticação não encontrado'
          } else if (response.status === 400 || response.status === 401) {
            mensagemErro = data.err === 'JWT is expired'
              ? 'Token de recuperação expirado. Solicite uma nova recuperação de senha.'
              : (data.err || 'Falha ao alterar senha')
          } else if (response.status === 500) {
            if (data.err && data.err.includes('nova senha deve ser diferente da atual')) {
              mensagemErro = 'A nova senha deve ser diferente da senha atual. Por favor, escolha uma senha diferente.'
            } else {
              mensagemErro = data.err || 'Erro interno do servidor ao alterar senha'
            }
          } else {
            mensagemErro = 'Falha ao alterar senha'
            if (data.err) {
              mensagemErro += ': ' + data.err
            }
          }

          throw new Error(mensagemErro)
        }

        bus.emit('siop-limpa-tudo')
        bus.emit('siop-sucesso', 'Senha alterada com sucesso! Faça login com sua nova senha.')
        this.$router.push('paginainicial')
      } catch (err) {
        bus.emit('siop-erro', err.message || 'Falha ao alterar senha')
      }
    },
    async submitLogin () {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('refreshToken')
      window.localStorage.removeItem('usuario')
      const usuario = { cpf: this.login, senha: this.senha }
      this.validandoLogin = true

      try {
        const response = await fetch(UiConfig.urls.auth.login, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(usuario)
        })

        if (!response.ok) {
          const data = await response.json().catch(() => ({}))
          const mensagens = {
            404: 'Serviço de autenticação não encontrado',
            400: data.err || 'Falha ao solicitar autenticação',
            401: data.err || 'Falha ao solicitar autenticação'
          }
          throw new Error(mensagens[response.status] || 'Falha ao solicitar autenticação')
        }

        const data = await response.json()
        this.validandoLogin = false
        window.localStorage.setItem('token', data.tokenSiop)
        window.localStorage.setItem('refreshToken', data.refreshToken)
        const usuarioDecodificado = jwtDecode(window.localStorage.getItem('token'))
        if (usuarioDecodificado.trocarSenha) {
          this.nova_senha = ''
          this.confirmacao_senha = ''
          this.trocarSenhaTokeExp = usuarioDecodificado.exp
          this.interval = setInterval(() => {
            this.updateRemaingTime()
          }, 1000)
          this.updateRemaingTime()
          bus.emit('siop-limpa-tudo')
        } else {
          document.location = UiConfig.paths.default
        }
      } catch (err) {
        this.validandoLogin = false
        bus.emit('siop-limpa-tudo')
        bus.emit('siop-erro', err.message || 'Falha ao solicitar autenticação')
      }
    },
    cancelarTrocarSenha () {
      if (!this.isRecuperacaoViaToken) {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('refreshToken')
        window.localStorage.removeItem('usuario')
      }
      this.$router.push('paginainicial')
      bus.emit('siop-limpa-tudo')
    }
  },
  mounted () {
    // Verificar se é acesso via token de recuperação
    const tokenParam = this.$route.query.token

    if (tokenParam && this.$route.path === '/definir-nova-senha') {
      // Fluxo de recuperação via token
      this.isRecuperacaoViaToken = true
      this.tokenRecuperacao = tokenParam

      try {
        // Decodificar o token para verificar se é válido e obter informações de expiração
        const tokenDecoded = jwtDecode(tokenParam)
        const now = Math.floor(Date.now() / 1000)

        if (tokenDecoded.exp <= now) {
          bus.emit('siop-erro', 'Token de recuperação expirado. Solicite uma nova recuperação de senha.')
          this.$router.push('paginainicial')
        }
      } catch (error) {
        console.log('Erro ao decodificar token:', error)
        bus.emit('siop-erro', 'Token de recuperação inválido.')
        this.$router.push('paginainicial')
      }
    } else {
      // Fluxo normal de troca de senha
      const token = window.localStorage.getItem('token')
      let usuario = {}
      try {
        if (token != null && token !== '' && token !== 'null') {
          usuario = jwtDecode(token)
          if (!usuario) {
            this.$router.push('paginainicial')
          } else if (usuario != null && usuario.trocarSenha) {
            this.trocarSenhaTokeExp = usuario.exp
            this.interval = setInterval(() => {
              this.updateRemaingTime()
            }, 1000)
            this.updateRemaingTime()
          } else {
            document.location = UiConfig.paths.default
          }
        } else {
          this.$router.push('paginainicial')
        }
      } catch (error) {
        console.log('-->', error)
      }
    }
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>
<style scoped src="@siop/standard-libui/dist/css/bootstrap-4/siop.css" />
